import React, { useRef, useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import Notification from "rc-notification";
import { confirmAlert } from "react-confirm-alert";

import { changeLanguage, saveUserToStorage, removeUserFromStorage } from "../redux/actions/sharedActions";

import { login, logout, checkLoginState } from "../helpers/apiOrderHelper";

import $ from "jquery";
window.jquery = window.$ = $;

let notification = null;
Notification.newInstance(
  {
    closable: true,
    duration: 3,
    style: {
      top: 50,
      right: 20,
      color: "#000",
    },
  },
  (n) => (notification = n)
);
const Header = (props) => {
  const refUserName = useRef(null);
  const refPassword = useRef(null);

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.gShared.language);
  const serverTime = useSelector((state) => state.gShared.serverTime);
  const serverDate = serverTime > 0 ? new Date(serverTime) : new Date();
  
  const userName = useSelector((state) => state.gUser.userName ?? "");
  const userToken = useSelector((state) => state.gUser.token ?? "");

  const { concurrentInfo } = useSelector(
    (state) => ({
      concurrentInfo: state.gShared.concurrentInfo,
    }),
    (prev, next) => {
      return prev.concurrentInfo?.time === next.concurrentInfo?.time;
    }
  );

  useEffect(() => {
    if ($) {
      $(".view-menu-mb").click((e) => {
        $(".listView").toggleClass("open-mb");
        $(e.target).toggleClass("change-icon-mb");
      });
      $(".listView li a").click((e) => {
        $(".listView").toggleClass("open-mb");
        $(".view-menu-mb").removeClass("change-icon-mb");
      });
      $(".changeview").click((e) => {
        document
          .querySelector('meta[name="viewport"]')
          .setAttribute("content", "user-scalable=no, width=device-width, initial-scale=0, minimum-scale=0, maximum-scale=2");
      });
    }
  }, [$]);

  //
  const _changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    changeLanguage(dispatch, lng);
  };

  const [nameClass, setNameClass] = useState("");

  const showpopup = () => {
    setNameClass("show");
  };

  const _handleInputKeyDown = (event) => {
    // console.log(event);
    if (event && event.keyCode === 13) {
      _userLogin();
    }
  };

  const _userLogin = () => {
    try {
      let _userName = "",
        _password = "";
      if (refUserName.current) {
        _userName = refUserName.current.value;
      }

      if (refPassword.current) {
        _password = refPassword.current.value;
      }

      //
      // if(_userName !== '067C001805' && _userName !== '067C000711'  && _userName !== '067C002369') {
      //     notification.notice({
      //         style: {
      //             color: 'red',
      //         },
      //         content: <span>User không được phép đăng nhập vào hệ thống hiện tại.</span>,
      //     });
      // }
      // else {
      login(_userName, _password)
        .then(function (response) {
          // console.log(response);
          if (response.status === 200) {
            if (response.data.status.Code === 0) {
              const _user = {
                updateTime: new Date().getTime(),
                userName: response.data.UserLogin.UserName,
                fullName: response.data.UserLogin.FullName,
                tellerName: response.data.UserLogin.TellerName,
                verifyOTP: response.data.UserLogin.VerifyOTP,
                token: response.data.ticket,
                tradingAccount: response.data.lsTradingUserInfo,
              };
              //
              notification.notice({
                style: {
                  color: "green",
                },
                content: "Đăng nhập thành công",
              });
              saveUserToStorage(_user);
              dispatch({ type: "SetUser", payload: _user });
              setNameClass("");
            } else {
              notification.notice({
                style: {
                  color: "red",
                },
                content: <span>{response.data.status.Msg}</span>,
              });
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
      // }
    } catch (error) {}
  };

  const _userLogout = () => {
    confirmAlert({
      title: t("bamDangXuat"),
      message: t("xacNhanDangXuatTaiKhoan"),
      buttons: [
        {
          label: t("dangXuat"),
          onClick: () => {
            logout();
            _clearUserMem();
          },
        },
        {
          label: t("huy"),
        },
      ],
    });
  };

  const _clearUserMem = () => {
    removeUserFromStorage();
    dispatch({ type: "ClearUser" });
  };

  const _setDefaultUser = () => {
    if (refUserName.current && refPassword.current) {
      refUserName.current.value = "";
      refPassword.current.value = "";
    } else {
      setTimeout(_setDefaultUser, 200);
    }
  };

  //
  useEffect(() => {
    _setDefaultUser();
    // Check user login state
    let intevalId = 0;
    if (userToken && userToken != "") {
      intevalId = setInterval(() => {
        checkLoginState(userToken)
          .then(function (response) {
            // console.log(response);
            if (response.status === 200 && response.data.status === 0) {
              //
            } else {
              _clearUserMem();
            }
          })
          .catch(function (error) {
            console.log(error);
            _clearUserMem();
          });
      }, 5000);
    } else {
      clearInterval(intevalId);
    }

    //
    return () => {
      clearInterval(intevalId);
    };
  }, [userToken]);

  const handleChangeLanguage = (e) => {
    _changeLanguage(e);
  };

  //
  return (
    <div className="header">
      <div className="header__left">
        <div className="flex__center">
          <div className="logo" style={{ marginRight: 16 }}>
            {/* <a href="/"><img src="/APG_LOGO.png" alt="img" /></a> */}
            <NavLink exact={true} to="/">
              <img src="/APG_LOGO.png" alt="img" />
            </NavLink>
          </div>
          <ul className="listView">
            <li>
              <NavLink activeClassName={"active"} to="/banggia">
                <img className="show-mb-img" src="/static/img/icon/icon-price-mb.svg" alt="img" /> {t("bangGia")}
              </NavLink>
            </li>
            {/* 23/04/2024 Ẩn tab thống kê ngành cho TVSI */}
            {/* <li>
              <NavLink activeClassName={"active"} to="/thongke">
                <img className="show-mb-img" src="/static/img/icon/icon-tkn.svg" alt="img" /> {t("thongKeNganh")}
              </NavLink>
            </li> */}
            <li className="showlistview-mb">
              <a className="changeview">
                <img className="show-mb-img" src="/static/img/icon/computer.png" alt="img" /> Hiển thị dạng trình duyệt
              </a>
            </li>
            <li className="showlistview-mb">
              <a onClick={() => showpopup()}>
                <img src="/static/img/icon/icon-login.svg" alt="img" />
                <span>{t("dangNhap")}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="header__center"></div>
      <div className="header__right">
        <div className="flex__center">
          <div className="flex__center timeline nowrap">
            <div className="timeline__now" style={{ fontWeight: "bolder" }}>
              <span style={{ color: "transparent" }}>
                t:{concurrentInfo.total}-m:{concurrentInfo.max}-c:{concurrentInfo.current}-
              </span>
              {serverDate.toLocaleTimeString("en-GB")}
            </div>
            <div className="timeline__date">{serverDate.toLocaleDateString("en-GB")}</div>
          </div>
          {language === "en" ? (
            <img src="/static/img/icon/icon-language-en.svg" alt={t("tiengAnh")} />
          ) : language === "zh" ? (
            <img src="/static/img/icon/icon-language-zh.svg" alt={t("tiengTrung")} />
          ) : (
            <img src="/static/img/icon/icon-language-vi.svg" alt={t("tiengViet")} />
          )}
          <select className="input-default change-language" onChange={(e) => handleChangeLanguage(e.target.value)}>
            <option selected={language === "vi" ? true : false} value="vi">
              {t("tiengViet")}
            </option>
            <option selected={language === "en" ? true : false} value="en">
              {t("tiengAnh")}
            </option>
            <option selected={language === "zh" ? true : false} value="zh">
              {t("tiengTrung")}
            </option>
            <option selected={language === "kr" ? true : false} value="kr">
              {t("tiengHan")}
            </option>
          </select>
          {userName && userName !== "" ? (
            <button className="btn__login d-none-mb" onClick={_userLogout}>
              <span>
                {/* <span className="fw-700 text-uppercase">{userName}</span> - {t("dangXuat")} */}
                {t("dangXuat")}
              </span>
            </button>
          ) : (
            <button className="btn__login d-none-mb" onClick={() => showpopup()}>
              <img src="/static/img/icon/icon-login.svg" alt="img" />
              <span>{t("dangNhap")}</span>
            </button>
          )}
        </div>
      </div>
      <div className="menu-private">
        <button className="view-menu-mb">
          <span className="line-main line-1"></span>
          <span className="line-main line-2"></span>
          <span className="line-main line-3"></span>
        </button>
      </div>

      {/* popup đăng nhập */}
      {userToken === "" ? (
        <div className={clsx("block-login", nameClass)}>
          <div className="bg-black" onClick={() => setNameClass("")}></div>
          <div className="form-login">
            <button className="btn-close-login" onClick={() => setNameClass("")}>
              <img src="/static/img/icon/btn-close-login.svg" alt="img" />
            </button>
            <div className="logo-login">
              <img src="/static/img/icon/icon-logo-login.svg" alt="img" />
            </div>
            <div className="form-login-input">
              <div className="flex-close popup__header--right">
                <button type="button" onClick={() => setNameClass("")}>
                  <img src="/static/img/icon/icon-close.svg" alt="img" />
                </button>
              </div>
              <p>Đăng nhập</p>
              <form action="">
                <span>Tên đăng nhập</span>
                <div className="field-login">
                  <input ref={refUserName} type="text" placeholder={t("taiKhoan")} autoFocus={true} onKeyDown={_handleInputKeyDown} />
                  <div className="icon-field">
                    <img src="/static/img/icon/icon-ac.svg" alt="img" />
                  </div>
                </div>

                <span>Mật khẩu</span>
                <div className="field-login">
                  <input ref={refPassword} type="password" placeholder={t("matKhau")} onKeyDown={_handleInputKeyDown} />
                  <div className="icon-field">
                    <img src="/static/img/icon/icon-password.svg" alt="img" />
                  </div>
                </div>

                <div className="text-right">
                  <a href="https://trading.apsi.vn/quen-mat-khau.html" className="forgot-password">
                    {t("quenMatKhau?")}
                  </a>
                </div>
                <button type="button" className="btn-login" onClick={_userLogin}>
                  {t("dangNhap")}
                </button>
                <div className="question-acc">
                  <a href="https://apsi.vn/huongdanmotaikhoan.html">{t("Mở tài khoản giao dịch")}</a>
                  <a href="https://apsi.vn/huongdanmotaikhoan.html">{t("Đăng ký tài khoản trải nghiệm")}</a>
                </div>
              </form>
              <div className="flex-footer">
                <div>
                  <span>Liên hệ hỗ trợ</span>
                  <span>Công bố rủi ro</span>
                </div>
                <span></span>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* end popup đăng nhập */}
    </div>
  );
};

export default Header;
